export const version = "wallet/5.3.0";
//# sourceMappingURL=_version.js.map